import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

import HubTableWithDataCard from './components/HubTableWithData';
import HubDetailSBSTable from './components/SBSTable/HubDetailSBSTable';
import HubDetailTrapTable from './components/MCTTable/HubDetailTrapsTable';
import HubTrapsChart from './components/TrapsChart/HubTrapsChart';
import HubTrapsChartTitle from './components/TrapsChart/HubTrapsChartTitle';

import useGetHubDetailPage from 'hooks/Traps/Hubs/useGetHubDetailPage';
import DeviceBreadCrump from 'components/DevicesDetail/DeviceDetailBreadCrump';
import { TrapTableType, TrapTableTypeLink } from 'components/TrapsTables/trapTables';
import TimeCard from 'components/DevicesDetail/MCT/TimeCard';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import QRCodeModal from 'components/QRCodeModal/QRCodeModal';
import TrapDeleteModal from 'components/DeleteTrapModal/TrapsDeleteModal';

const HubDetail: React.FC = () => {
  const { slug } = useParams();
  const { data, isLoading, isRefetching, refetch } = useGetHubDetailPage(slug || '');
  useEffect(() => {
    refetch();
  }, [slug, refetch]);

  return (
    <div className="page-content">
      <Container fluid>
        <DeviceBreadCrump
          dropDownData={data?.hub.select_hub_dropdow_data || null}
          objSlug={data?.hub.object_slug || ''}
          objName={data?.hub.object_name || ''}
          sq={data?.hub.sequence_number || ''}
          sn={data?.hub.serial_number || ''}
          deviceType={TrapTableType.Hubs}
          isLoading={isLoading}
          slug={slug || ''}
          deviceName="hub"
        />
        <div className="row">
          <div className="col-xl-3">
            <div>
              <TimeCard work_time={data?.hub.work_time || 0} />
              <HubTableWithDataCard
                data={data || null}
                isLoading={isLoading}
                slug={slug || ''}
                isRefetching={isRefetching}
              />
            </div>
          </div>
          <div className="col-xl-9 px-xl-0 ">
            <div className="card shadow-lg">
              <HubTrapsChartTitle />
              <HubTrapsChart slug={slug || ''} isLoading={isLoading} data={data} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6  px-xl-2.5">
            <div className="card card-height-100 shadow-lg">
              <HubDetailTrapTable
                data={data?.mct || []}
                trapType={TrapType.MCT}
                isLoading={isLoading}
                refetch={refetch}
                slug={data?.hub.object_slug || ''}
                deviceType={TrapTableTypeLink.MultiCatchMouseTraps}
              />
            </div>
          </div>
          <div className="col-xl-6 px-xl-0">
            <div className="card card-height-100 shadow-lg">
              <HubDetailSBSTable
                data={data?.srbm || []}
                isLoading={isLoading}
                refetch={refetch}
                slug={data?.hub.object_slug || ''}
                deviceType={TrapTableTypeLink.SmartRodenBaitModule}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6 px-xl-2.5">
            <div className="card card-height-100 shadow-lg">
              <HubDetailTrapTable
                data={data?.srst || []}
                trapType={TrapType.SRST}
                isLoading={isLoading}
                refetch={refetch}
                slug={data?.hub.object_slug || ''}
                deviceType={TrapTableTypeLink.SnapTrapRat}
              />
            </div>
          </div>
          <div className="col-xl-6 px-xl-0">
            <div className="card card-height-100 shadow-lg">
              <HubDetailTrapTable
                data={data?.smst || []}
                trapType={TrapType.SMST}
                isLoading={isLoading}
                refetch={refetch}
                slug={data?.hub.object_slug || ''}
                deviceType={TrapTableTypeLink.SnapTrapMouse}
              />
            </div>
          </div>
        </div>
        <div className="row" />
      </Container>
      <QRCodeModal />
      <TrapDeleteModal refetchTraps={refetch} refetchWarehouse={refetch} />
    </div>
  );
};

export default HubDetail;
